import React from 'react'

const ParametreContent = () => {
  return (
    <div>Content</div>
  )
}

export default ParametreContent